import styled, { css } from 'styled-components';

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 24px;
    border-radius: 16px;
    background-color: ${theme.v3.colors.neutral[100]};
    box-shadow: 0 2px 4px 0 ${theme.v3.colors.neutral[90]}24, 0 2px 4px 0 ${theme.v3.colors.neutral[90]}33;   
    
    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      align-items: flex-start;
    }
  `}
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes['1xlarge']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: 24px;
    }
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
    }  
  `}
`;

export const TextFieldWrapper = styled.div`
  ${({ theme }) => css`
    width: 320px;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;
